// @flow
import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import PropTypes from 'prop-types'

const Layout = ({ children }) => (
  <div>
    {children}
    <ToastContainer position="top-center" />
  </div>
)

Layout.propTypes = {
  children: PropTypes.any
}

export default Layout
